import * as Tooltip from '@radix-ui/react-tooltip';
import { Button, Icon } from '@smartgift/frontend-toolkit';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { NavigationB2B, NavigationBulkGifting, NavigationSmartgift } from '@hero/components/atoms';
import { useGetProviderUrl } from '@hero/services/organization-service/hooks';
import { getNavigationLink } from '@hero/utils';

import * as S from './style';

const DEFAULT_APP_NAME = 'smartgift';

function AppNavigation() {
  const { t } = useTranslation();
  const navRefs = useRef([]);

  const { data: providerUrl } = useGetProviderUrl();

  const navigationApps = t('navigationApps', { returnObjects: true });
  if (!Array.isArray(navigationApps) || !navigationApps?.length) return;

  const appMap = {
    b2b: {
      Icon: NavigationB2B,
      href: providerUrl?.loginLink ?? getNavigationLink('b2b')
    },
    bulkGifting: {
      Icon: NavigationBulkGifting,
      href: getNavigationLink('bulkGifting')
    },
    smartgift: {
      Icon: NavigationSmartgift
    }
  };

  const navigations = navigationApps?.map(nav => ({
    ...nav,
    ...appMap[nav.appName]
  }));

  const defaultIndex = navigations?.findIndex(nav => nav.appName === DEFAULT_APP_NAME);

  const salesNumber = t('salesNumber');

  return (
    <S.AppNavigation>
      <S.AppNavigationItems>
        <Tooltip.Provider>
          {navigations?.map((nav, navIndex) => {
            const NavIcon = styled(nav.Icon)``;

            return (
              <Tooltip.Root key={nav.title}>
                <Tooltip.Trigger asChild>
                  {nav.isExternal ? (
                    <S.NavExternalLink
                      ref={el => (navRefs.current[navIndex] = el)}
                      isActive={navIndex === defaultIndex}
                      href={nav.href ?? getNavigationLink(nav.appName)}
                    >
                      <NavIcon />
                    </S.NavExternalLink>
                  ) : (
                    <S.NavLink
                      ref={el => (navRefs.current[navIndex] = el)}
                      isActive={navIndex === defaultIndex}
                      to={nav.href}
                    >
                      <NavIcon />
                    </S.NavLink>
                  )}
                </Tooltip.Trigger>

                <Tooltip.Portal>
                  <S.TooltipContent sideOffset={5}>
                    <S.TooltipArrow />
                    {nav.tooltipContent}
                  </S.TooltipContent>
                </Tooltip.Portal>
              </Tooltip.Root>
            );
          })}
        </Tooltip.Provider>
      </S.AppNavigationItems>

      {salesNumber && (
        <Button
          as="a"
          href={`tel:${salesNumber}`}
          variant="link"
          color="secondary"
          startIcon={<Icon name="phone" />}
          style={{ marginTop: -5 }}
        >
          {salesNumber}
        </Button>
      )}
    </S.AppNavigation>
  );
}

export { AppNavigation };
